import { Component,  ViewChildren, AfterViewInit, QueryList ,OnInit,Input, Output ,EventEmitter ,ElementRef} from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';

@Component({
  selector: 'app-editquiz',
  templateUrl: './editquiz.component.html',
  styleUrls: ['./editquiz.component.scss'],
})
export class EditquizComponent implements OnInit {

  @Input() json : any;
  @Input() id : number;
  @Input() type : string;

  @Output() eventchild = new EventEmitter<string>();

  //@ViewChild('idlabel', {static: true}) idlabel :  ElementRef;
  
  @ViewChildren('idlabel') idlabel : QueryList<any>;

  //ngAfterViewInit() {
  //this.hellos.forEach(hello => console.log(hello));
  //}


  tabQuest: any;
  nbquest : number;
  
  constructor(public gfichier : GfichierService) { }

  ngOnInit() {
  
  }

  ngOnChanges() {
    this.tabQuest = this.getTabQuest();
  }

    //retourne la page 
    getTabQuest() {
    
      //alert(this.posiquest);
      //alert(this.tabQuest[0]);
      //let lgTab = this.tabQuest[this.posiquest].length;
      this.nbquest = Object.keys(this.json).length;
    
      let tabArray = []; 
     
      let sol : boolean;
   
      for (let i =0 ; i< this.nbquest;i++) {
         // rep = false;
          sol = false;
          if(this.json[i].sol) sol=true;
          
          tabArray.push({
             id : i,
             label : this.json[i].label,
             sol : sol
          //   rep : rep
         });
  
          //alert(this.tabPosQuest[i] +" " + tabArray[i].rep + " " +  tabArray[i].sol );
   
        
      }//fin for
  
     // alert(tabArray); 
      return tabArray; 
      // alert(this.route.snapshot.paramMap.get("idp"));
  
    }

    changeCheckbox(numero:number) {
     
      this.json[numero].sol = !this.json[numero].sol;
       
    
    }


  plusrep() {
    this.json.push(JSON.parse('{"label":"","sol":false}'));
    this.enregistrer();
  }

  moinsrep() {
   // this.json[this.nbquest] = JSON.parse('{"label":"","sol":false}'):
   if (this.nbquest > 2) {
      
    let jsonText : string ="[";
    //alert(JSON.stringify(this.tabPages[j]));
    for (let i = 0; i < this.nbquest-1; i++) {
           jsonText = jsonText + JSON.stringify(this.json[i]);
           jsonText = jsonText +  ",";
    }
    //alert(this.tabPages[0]);
    jsonText = jsonText.slice(0,-1);
    jsonText =  jsonText + "]";

    //alert(jsonText);
    // alert(jsonText);
    this.json = JSON.parse(jsonText);

    this.tabQuest = this.getTabQuest();
    
    setTimeout(() => {
      this.enregistrer();
    }, 500);
     
    //this.nbquest = Object.keys(this.json).length;

    //this.enregistrer();
  }

   // thie.enregistrer();
  
  }

    

  enregistrer() {
      
      
      //met à jour les labels
      let i=0;

      this.idlabel.forEach(idlab => {
        this.json[i].label = idlab.nativeElement.innerHTML;
        i++;
      });
    
      
     this.gfichier.setValue(this.json,this.id,this.type);
      
     this.eventchild.emit("enregistrer");
      
  }

}
